
function appLog(data) {
    if(plannerApplication === null || plannerApplication.config.debugMode) {
        console.log(data);
    }
}

function appLogAttr(model, attr, value) {
    appLog(''+model+'->'+attr+' = '+value);
}

function appLogObject(model, attr, obj) {
    appLog(''+model+'->'+attr+':');
    appLog(obj);
}
